import React from "react";
import { css, cx } from "emotion";

type Props = {
  icon: JSX.Element;
  hoverColor?: string;
  color?: string;
};

export const IconButton: React.FC<React.HTMLProps<HTMLSpanElement> & Props> = props => {
  // throw away hoverColor to remove warning about it not being a valid DOM property
  const { hoverColor: _, ...htmlProps } = props;

  return (
    <span
      className={cx(
        props.className,
        css`
          cursor: pointer;
          color: ${props.color ? props.color : "lightgray"};
          &:hover {
            color: ${props.hoverColor ? props.hoverColor : "black"};
          }
        `
      )}
      {...htmlProps}
    >
      {props.icon}
    </span>
  );
};
